var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.items.length > 0)?_c('div',[_c('VueSlickCarousel',{staticClass:"mt-3",attrs:{"arrows":true,"dots":false,"slidesToScroll":1,"slidesToShow":3,"responsive":[
				{
					breakpoint: 1720,
					settings: {
						slidesToShow: 3
					}
				},
				{
					breakpoint: 1400,
					settings: {
						slidesToShow: 3
					}
				},
				{
					breakpoint: 991,
					settings: {
						slidesToShow: 2
					}
				},
				{
					breakpoint: 480,
					settings: {
						slidesToShow: 1
					}
				}
			]},scopedSlots:_vm._u([{key:"prevArrow",fn:function(){return [_c('div',{staticClass:"custom-arrow"},[_c('svg',{staticClass:"icon icon-tabler icon-tabler-chevron-left",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24","stroke-width":"2","stroke":"currentColor","fill":"none","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"stroke":"none","d":"M0 0h24v24H0z","fill":"none"}}),_c('polyline',{attrs:{"points":"15 6 9 12 15 18"}})])])]},proxy:true},{key:"nextArrow",fn:function(){return [_c('div',{staticClass:"custom-arrow"},[_c('svg',{staticClass:"icon icon-tabler icon-tabler-chevron-right",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24","stroke-width":"2","stroke":"currentColor","fill":"none","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"stroke":"none","d":"M0 0h24v24H0z","fill":"none"}}),_c('polyline',{attrs:{"points":"9 6 15 12 9 18"}})])])]},proxy:true}],null,false,1868006489)},[_vm._l((_vm.items),function(item){return [_c('div',{key:item.id,staticClass:"p-2"},[_c('ProductItem',{attrs:{"item":item}})],1)]})],2)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }